/* Countdown page.
   No buttons, no links, no navigation. The page does three things: count down,
   move two jaws, and make noise once the browser lets it. */

(function () {
  'use strict';

  // ==========================================================================
  // THE DEADLINE lives in reveal.config.json, not here. The server reads it and
  // writes it into the page, so there is exactly one source of truth and the
  // countdown, the local preview and the Liquid gate can never disagree.
  //
  // FALLBACK is only for opening index.html straight off disk with no server.
  // In that state the page counts down but can NEVER reveal: see trusted below.
  // ==========================================================================
  var FALLBACK_TARGET = '2026-08-08T18:00:00+02:00';

  var targetMs = window.DEADLINE_MS || new Date(FALLBACK_TARGET).getTime();

  // ------------------------------------------------------------ trusted clock
  //
  // The countdown used to run on Date.now(), which is the visitor's own system
  // clock and is therefore a suggestion, not a fact. Winding the clock forward
  // or changing timezone ran the timer out early.
  //
  // Now the server stamps the real time into the page at render, and elapsed
  // time comes from performance.now(), which is monotonic: it counts real
  // seconds since page load and does not move when the system clock does. So
  // the only thing a visitor controls is when they loaded the page, and loading
  // it later only ever makes the deadline closer, never further away.
  //
  // trusted=false means we never got a server time. The clock still draws, but
  // reveal() refuses to fire. Fail closed.
  // Sanity floor, not just a type check. If Shopify's {{ 'now' }} ever rendered
  // empty the script would still parse, as window.SERVER_NOW_MS=000, and a
  // server time of 0 would draw a clock reading several hundred thousand hours.
  // Anything before 2020 is a broken render, so distrust it: the countdown falls
  // back to the local clock for DISPLAY and, being untrusted, still cannot
  // reveal anything. The Liquid gate fails closed in the same case.
  var MIN_SANE_MS = 1577836800000;      // 2020-01-01
  var serverAtSync = (typeof window.SERVER_NOW_MS === 'number' &&
                      window.SERVER_NOW_MS > MIN_SANE_MS) ? window.SERVER_NOW_MS : null;
  var perfAtSync = performance.now();
  var trusted = serverAtSync !== null;

  function nowMs() {
    if (!trusted) return Date.now();          // display only, never gates anything
    return serverAtSync + (performance.now() - perfAtSync);
  }

  // Re-anchor to the server. Called with the Date header off any response we
  // make, so a page left open for hours cannot drift.
  function resync(dateHeader) {
    if (!dateHeader) return;
    var t = new Date(dateHeader).getTime();
    if (!isFinite(t) || t < MIN_SANE_MS) return;    // same floor as the seed
    serverAtSync = t;
    perfAtSync = performance.now();
    trusted = true;
  }

  var CADENCE = window.LAUGH_CADENCE || [0];
  var LAUGH_LEN = window.LAUGH_LEN || 4.6;
  var HA_WIDTH = 0.22;        // how long one jaw drop takes, seconds
  var HEARTBEAT = 1.5;        // matches the thump spacing baked into drone.mp3

  var clockEl = document.getElementById('clock');
  var stageEl = document.getElementById('stage');
  var flashEl = document.getElementById('flash');
  var hintEl = document.getElementById('hint');

  var drone = document.getElementById('drone');
  // Shopify serves assets from its CDN under generated URLs, so the layout sets
  // this. Falls back to the local path for the preview server.
  var tickSrc = window.TICK_SRC || 'assets/audio/tick.mp3';

  // How long a face stays quiet after the last laugh finished. Wide and random,
  // so the two of them never settle into a rhythm you can predict.
  var WAIT_MIN = 6.0;
  var WAIT_MAX = 17.0;
  var GAP_AFTER = 0.6;        // silence enforced before the other one may start

  // Filtered, so a face can be pulled out of the markup without breaking the
  // page. Right now only Allan is on it.
  var faces = [
    { el: document.getElementById('face-a'), audio: document.getElementById('laugh-a') },
    { el: document.getElementById('face-b'), audio: document.getElementById('laugh-b') }
  ].filter(function (f) { return f.el && f.audio; });

  var busyUntil = 0;          // no two faces laugh over each other

  function rand(a, b) { return a + Math.random() * (b - a); }

  var audioOn = false;

  // --------------------------------------------------------------- countdown

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  var lastSecond = -1;

  function drawClock(nowMs) {
    var left = Math.max(0, targetMs - nowMs);
    var total = Math.floor(left / 1000);

    if (total !== lastSecond) {
      var h = Math.floor(total / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;
      var text = pad(h) + ':' + pad(m) + ':' + pad(s);
      clockEl.textContent = text;
      // The tab counts down too. It is also the only name this page has.
      document.title = text;

      // One tick per second, but never while the tab is hidden and never
      // catching up on a backlog after the tab wakes.
      if (audioOn && lastSecond >= 0 && !document.hidden) playTick();

      if (total === 0) clockEl.classList.add('done');
      lastSecond = total;
    }
  }

  // --------------------------------------------------------------- laughter

  // A face laughs, then shuts up for a random stretch. If its turn comes round
  // while the other one is still going, it waits rather than talking over them.
  function startLaugh(face, now) {
    face.laughStart = now;
    face.laughUntil = now + LAUGH_LEN * 1000;
    busyUntil = face.laughUntil + GAP_AFTER * 1000;
    face.nextAt = face.laughUntil + rand(WAIT_MIN, WAIT_MAX) * 1000;

    if (audioOn) {
      try {
        face.audio.currentTime = 0;
        var p = face.audio.play();
        if (p && p.catch) p.catch(function () {});
      } catch (e) { /* nothing to do but stay silent */ }
    }
  }

  function tickLaughter(now) {
    for (var i = 0; i < faces.length; i++) {
      var f = faces[i];
      if (now < f.laughUntil) continue;                 // mid laugh
      if (now < f.nextAt) continue;                     // still resting
      if (now < busyUntil) {                            // the other one has the floor
        f.nextAt = busyUntil + rand(0.4, 3.0) * 1000;
        continue;
      }
      startLaugh(f, now);
    }
  }

  // Where a face is inside its own laugh. Driven by the audio element when sound
  // is playing so the jaws can never drift off the syllables, and by the page
  // clock when it is silent.
  function phaseOf(face, now) {
    if (now >= face.laughUntil) return -1;              // mouth shut
    if (audioOn && !face.audio.paused && face.audio.duration) {
      return face.audio.currentTime;
    }
    return (now - face.laughStart) / 1000;
  }

  function openness(phase) {
    if (phase < 0) return 0.05;
    var best = 0;
    for (var i = 0; i < CADENCE.length; i++) {
      var u = (phase - CADENCE[i]) / HA_WIDTH;
      if (u >= 0 && u <= 1) {
        var v = Math.sin(Math.PI * u);
        if (v > best) best = v;
      }
    }
    // Never fully shut, so the split always reads as a split.
    return 0.06 + best * 0.94;
  }

  // --------------------------------------------------------------- loop

  var startedAt = performance.now();

  function frame(now) {
    var tSec = (now - startedAt) / 1000;

    // Vignette breathes on the same 1.5s beat as the drone's heartbeat,
    // locked to the drone's own playback position when it is running. Kept
    // outside the branch below so the room keeps breathing after the reveal.
    var beatT = (audioOn && !drone.paused) ? drone.currentTime : tSec;
    var beat = (beatT % HEARTBEAT) / HEARTBEAT;
    var pulse = Math.pow(Math.max(0, 1 - beat * 3.2), 2);
    document.documentElement.style.setProperty('--pulse', pulse.toFixed(3));

    if (revealed) {
      revealFrame(now);
    } else {
      drawClock(nowMs());
      if (nowMs() >= targetMs) tryReveal();
      tickLaughter(now);

      for (var i = 0; i < faces.length; i++) {
        faces[i].el.style.setProperty('--open', openness(phaseOf(faces[i], now)).toFixed(3));
      }
    }

    requestAnimationFrame(frame);
  }

  // --------------------------------------------------------------- glitch

  function glitch() {
    // The stage is gone once the payload is up, and a white flash across the
    // video would read as a bug rather than as the room being wrong.
    if (revealed) return;
    stageEl.classList.add('glitch');
    flashEl.classList.add('on');
    setTimeout(function () { flashEl.classList.remove('on'); }, 70);
    setTimeout(function () { stageEl.classList.remove('glitch'); }, 340);
    setTimeout(glitch, 5200 + Math.random() * 9000);
  }

  // --------------------------------------------------------------- audio

  // A small pool so consecutive ticks never cut each other off.
  var ticks = [];
  var tickAt = 0;
  for (var t = 0; t < 3; t++) {
    var a = new Audio(tickSrc);
    a.volume = 0.34;
    ticks.push(a);
  }

  function playTick() {
    var a = ticks[tickAt++ % ticks.length];
    try { a.currentTime = 0; a.play(); } catch (e) { /* pre-gesture, ignore */ }
  }

  function fadeTo(el, target, ms) {
    var from = el.volume;
    var t0 = performance.now();
    (function step(now) {
      // Clamped at BOTH ends. requestAnimationFrame hands back the timestamp of
      // the start of the frame, which can be slightly EARLIER than the
      // performance.now() captured a moment ago, making k negative and the
      // volume negative with it. The browser then throws, the fade dies where
      // it stands, and the drone is left stuck at whatever volume it had.
      var k = Math.max(0, Math.min(1, (now - t0) / ms));
      el.volume = from + (target - from) * k;
      if (k < 1) requestAnimationFrame(step);
    })(performance.now());
  }

  // Browsers will not make sound until the visitor does something. Any gesture
  // counts, so there is still nothing on screen to click.
  var GESTURES = ['pointerdown', 'pointermove', 'touchstart', 'keydown', 'wheel', 'scroll'];

  function wakeAudio() {
    if (audioOn) return;
    audioOn = true;
    GESTURES.forEach(function (g) { window.removeEventListener(g, wakeAudio); });

    hintEl.classList.add('gone');

    drone.volume = 0;
    var started = drone.play();
    if (started && started.catch) {
      started.catch(function () { audioOn = false; arm(); });   // gesture was not enough, wait for the next
    }
    fadeTo(drone, 0.52, 2200);

    // Laughs are fired by the scheduler, not started here. Just set the level
    // they will play at, and let a face already mid-laugh pick up the sound.
    faces.forEach(function (f, i) {
      f.audio.volume = i === 0 ? 0.62 : 0.55;
      if (performance.now() < f.laughUntil) {
        f.audio.currentTime = Math.max(0, (performance.now() - f.laughStart) / 1000);
        var pr = f.audio.play();
        if (pr && pr.catch) pr.catch(function () {});
      }
    });
  }

  function arm() {
    GESTURES.forEach(function (g) {
      window.addEventListener(g, wakeAudio, { passive: true });
    });
  }

  // --------------------------------------------------------------- reveal
  //
  // Two beats, in order: the video owns the whole screen for holdMs, then it is
  // replaced by one face laughing, and that is the site until someone changes
  // the theme by hand.
  //
  // Nothing in this file names the video or the face. All of it arrives in the
  // payload, and the payload only exists in the page once the SERVER's clock is
  // past the deadline. Reading this file, the CSS, or the assets before then
  // tells you a reveal happens. It does not tell you what it is, and no amount
  // of clock fiddling will make one arrive early.

  // How far the final face's jaw is allowed to travel, as a share of the
  // countdown's own drop. Raise it and the open mouth becomes a bar across the
  // face; see the note in style.css. 0.34 is the most it takes before it goes.
  var RV_OPEN_MAX = 0.34;

  var revealed = false;
  var rv = null;              // the payload, once the server hands it over
  var rvStage = null;         // 'video' then 'laugh'
  var rvEls = [];
  var rvVideoEl = null;
  var rvFace = null;
  var rvAudio = null;
  var rvSwitchAt = 0;
  var rvLaughStart = 0;
  var probing = false;
  var probeAfter = 0;

  // Keep the current query string: it is what carries the dev deadline in the
  // local preview, and dropping it would make the request ask about a different
  // clock than the one on screen. The cache buster is what stops a browser or a
  // proxy answering with the copy it already had.
  function probeUrl(tag) {
    return location.pathname + location.search +
           (location.search ? '&' : '?') + tag + '=' + Math.floor(performance.now());
  }

  // Ask the server whether it is time. The answer IS the payload: if the server
  // is still short of the deadline it returns a page with no payload in it and
  // there is nothing to act on. There is no boolean here to flip.
  function tryReveal() {
    if (revealed) return;
    if (window.REVEAL) { beginReveal(window.REVEAL); return; }
    if (!trusted) return;                    // never got a server time: stay put
    if (probing || performance.now() < probeAfter) return;
    probing = true;

    fetch(probeUrl('rv'), { cache: 'no-store' })
      .then(function (res) {
        resync(res.headers.get('date'));     // also our drift correction
        return res.text();
      })
      .then(function (html) {
        var el = new DOMParser().parseFromString(html, 'text/html')
                   .querySelector('#rv-data');
        if (el) beginReveal(JSON.parse(el.textContent));
      })
      .catch(function () { /* offline or blocked: keep counting, reveal nothing */ })
      .then(function () {
        probing = false;
        probeAfter = performance.now() + 2000;
      });
  }

  // ------------------------------------------------------- stale page rescue
  //
  // This page is meant to be left open for hours, which makes a stale copy a
  // real problem rather than a theoretical one: a tab opened before a deploy, or
  // a browser that served a cached page, would be counting to the wrong moment
  // with the wrong code, and would sit at zero and never reveal.
  //
  // So every few minutes it asks the server what the deadline is now. If the
  // answer disagrees with what this page was built with, the page reloads
  // itself. The same request re-anchors the clock, so a tab left open all night
  // cannot drift, and it catches the reveal for a backgrounded tab whose
  // animation frames have been throttled to a crawl.
  //
  // This cannot rescue a page that is ALREADY stale, because that copy is
  // running the old script with no heartbeat in it. It protects every page
  // served from now on.
  var HEARTBEAT_MS = 240000;                 // 4 minutes

  function heartbeat() {
    if (revealed) return;
    fetch(probeUrl('hb'), { cache: 'no-store' })
      .then(function (res) {
        resync(res.headers.get('date'));
        return res.text();
      })
      .then(function (html) {
        var m = html.match(/window\.DEADLINE_MS\s*=\s*(\d+)/);
        if (m && Number(m[1]) !== targetMs) {
          // Capped, so an inconsistency upstream can never put a visitor into a
          // reload loop. Three tries is plenty to pick up a new deadline.
          var n = 0;
          try { n = parseInt(sessionStorage.getItem('rvReloads') || '0', 10) || 0; } catch (e) {}
          if (n < 3) {
            try { sessionStorage.setItem('rvReloads', String(n + 1)); } catch (e) {}
            location.reload();
            return;
          }
        }
        var el = new DOMParser().parseFromString(html, 'text/html')
                   .querySelector('#rv-data');
        if (el) beginReveal(JSON.parse(el.textContent));
      })
      .catch(function () { /* offline: keep counting, change nothing */ });
  }

  function beginReveal(cfg) {
    if (revealed) return;
    revealed = true;
    rv = cfg;

    // Silence and strike the countdown. The overlays stay on purpose: the
    // vignette, scanlines and grain are the room, not the content.
    try { drone.pause(); } catch (e) {}
    faces.forEach(function (f) { try { f.audio.pause(); } catch (e) {} });
    ticks.forEach(function (a) { try { a.pause(); } catch (e) {} });
    if (stageEl) stageEl.remove();
    if (hintEl) hintEl.remove();
    document.title = '';

    startVideo();
  }

  // No browser will autoplay with sound, so the clip starts muted and the sound
  // is taken back at the first opportunity. Two things make that safe:
  //
  //   1. Only unmute something that is ALREADY playing. Asking for sound before
  //      playback starts gets the whole thing refused, leaving a silent still
  //      frame, which is worse than a muted video and only happens on a slow
  //      load, so it would not show up in testing.
  //   2. If the browser objects anyway it responds by pausing us. So check, and
  //      if we have been paused, give the sound back and keep the picture
  //      running until a real gesture arrives.
  //
  // Anyone who actually watched the clock hit zero has already gestured (that
  // is what started the drone) and the page was never reloaded, so for them the
  // sound is there from the first frame.
  function tryUnmute() {
    if (!rvVideoEl || !rvVideoEl.muted || rvVideoEl.paused) return;
    rvVideoEl.muted = false;
    rvVideoEl.volume = 1;
    setTimeout(function () {
      if (rvVideoEl && rvVideoEl.paused) {
        rvVideoEl.muted = true;
        var p = rvVideoEl.play();
        if (p && p.catch) p.catch(function () {});
      }
    }, 60);
  }

  function onGesture() {
    if (!rvVideoEl) return;
    var p = rvVideoEl.play();          // covers autoplay having been blocked
    if (p && p.catch) p.catch(function () {});
    tryUnmute();
  }

  function startVideo() {
    rvStage = 'video';

    var wrap = document.createElement('div');
    wrap.className = 'rv rv-video';

    rvVideoEl = document.createElement('video');
    rvVideoEl.src = rv.video;
    rvVideoEl.autoplay = true;
    rvVideoEl.muted = true;            // the only condition under which autoplay is allowed
    rvVideoEl.controls = false;
    rvVideoEl.preload = 'auto';
    // Both spellings: iOS will otherwise take the video fullscreen in its own
    // player chrome, which would put a UI on a page that is supposed to have none.
    rvVideoEl.playsInline = true;
    rvVideoEl.setAttribute('playsinline', '');
    rvVideoEl.setAttribute('webkit-playsinline', '');
    wrap.appendChild(rvVideoEl);

    document.body.appendChild(wrap);
    rvEls.push(wrap);

    // It hands over on its own, at its natural length, rather than on a timer
    // that would have to be kept in sync with the file.
    rvVideoEl.addEventListener('ended', startLaughFace);
    rvVideoEl.addEventListener('playing', tryUnmute);
    GESTURES.forEach(function (g) {
      window.addEventListener(g, onGesture, { passive: true });
    });

    var p = rvVideoEl.play();
    if (p && p.catch) p.catch(function () {});

    // Dead man's switch. If 'ended' never arrives because the clip stalled or
    // failed to decode, the page still moves on instead of sitting on a frozen
    // frame for the rest of its life.
    rvSwitchAt = performance.now() + (rv.holdMsFallback || 22000);
  }

  // Bound to pointermove among others, which fires continuously, so it has to
  // be cheap and idempotent: bail unless the audio is actually stopped.
  function playLaugh() {
    if (!rvAudio || !rvAudio.paused) return;
    var p = rvAudio.play();
    if (p && p.catch) p.catch(function () {});
  }

  function startLaughFace() {
    // 'ended' and the dead man's switch can both fire; whichever is first wins.
    if (rvStage === 'laugh') return;
    rvStage = 'laugh';

    // The video goes before the face arrives, so there is never a frame with
    // both on screen and nothing is left behind it.
    if (rvVideoEl) {
      rvVideoEl.removeEventListener('ended', startLaughFace);
      rvVideoEl.removeEventListener('playing', tryUnmute);
      try { rvVideoEl.pause(); } catch (e) {}
      rvVideoEl.removeAttribute('src');
      rvVideoEl.load();                 // stops it decoding behind the face
    }
    rvEls.forEach(function (el) { el.remove(); });
    rvEls.length = 0;
    rvVideoEl = null;
    GESTURES.forEach(function (g) { window.removeEventListener(g, onGesture); });

    var f = rv.face;
    var host = document.createElement('div');
    host.className = 'rv rv-laugh';

    rvFace = document.createElement('figure');
    rvFace.className = 'face rv-face';
    rvFace.style.cssText =
      '--cw:' + f.cw + ';--ch:' + f.ch + ';--split:' + f.split +
      ';--head-cx:' + f.headCx + ';--cavity-w:' + f.cavityW;

    // Same three-layer stack as the countdown face: cavity behind, top, then
    // the jaw that is the only thing that ever moves.
    [['cavity', f.cavity], ['top', f.top], ['jaw', f.jaw]].forEach(function (part) {
      var img = document.createElement('img');
      img.className = part[0];
      img.src = part[1];
      img.alt = '';
      if (part[0] !== 'top') img.setAttribute('aria-hidden', 'true');
      rvFace.appendChild(img);
    });

    host.appendChild(rvFace);
    document.body.appendChild(host);
    rvEls.push(host);

    rvAudio = new Audio(rv.laugh);
    rvAudio.loop = true;                     // back to back, so it never settles
    rvAudio.volume = 0.9;
    playLaugh();
    GESTURES.forEach(function (g) {
      window.addEventListener(g, playLaugh, { passive: true });
    });

    rvLaughStart = performance.now();
  }

  function revealFrame(now) {
    if (rvStage === 'video') {
      if (now >= rvSwitchAt) startLaughFace();
      return;
    }
    if (rvStage === 'laugh' && rvFace) {
      // Driven by the audio's own position while it plays, so the jaw cannot
      // drift off the syllables, and by the page clock while it is silent.
      var phase;
      if (rvAudio && !rvAudio.paused && rvAudio.duration) phase = rvAudio.currentTime;
      else phase = ((now - rvLaughStart) / 1000) % LAUGH_LEN;
      // Capped: see the note in style.css. Past about a third open, the gap
      // stops reading as a mouth on this face and becomes a bar across it.
      rvFace.style.setProperty('--open', (openness(phase) * RV_OPEN_MAX).toFixed(3));
    }
  }

  // --------------------------------------------------------------- go

  // Stagger the openings so two faces never start together on load.
  faces.forEach(function (f, i) {
    f.laughUntil = 0;
    f.nextAt = performance.now() + rand(2.0 + i * 5, 4.5 + i * 8.5) * 1000;
  });

  drawClock(nowMs());

  // Someone arriving after zero gets the payload straight away: the server
  // already put it in the page, so there is no countdown to sit through. They
  // get the video for holdMs and then the face, same as everyone who watched.
  if (window.REVEAL) {
    beginReveal(window.REVEAL);
  } else {
    setTimeout(glitch, 4000 + Math.random() * 4000);
    arm();
    // Only matters for a page left open a long time, which is the normal way
    // this page is used.
    setInterval(heartbeat, HEARTBEAT_MS);
  }

  requestAnimationFrame(frame);
})();
